import { useRequestHandler } from '@/hooks/useRequestHandler'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { UpdateAuthUserDto } from '@/core/classes/Auth'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser, selectAuthUserUpdateRequestState, updateMyProfile } from '@/redux/reducers/auth.reducer'

import { isStaff } from '@/utils/type-guards'

export function useStatusSwitch(waitingRoomId: string) {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const authUser = useAppSelector(selectAuthUser)

  const checked = isStaff(authUser) && !!waitingRoomId && !!authUser.activeWaitingRooms.includes(waitingRoomId)

  const { dispatch } = useRequestHandler<UpdateAuthUserDto>({
    onSuccess: (dispatchedValue: UpdateAuthUserDto | null) => {
      const isAvailable = waitingRoomId && !!dispatchedValue?.activeWaitingRooms?.includes(waitingRoomId)
      enqueueSnackbar(t('notification.authUser.updateWaitingRoomAvailability.success', { context: isAvailable ? 'available' : 'unavailable' }), {
        variant: 'success',
      })
    },
    onError: () => {
      enqueueSnackbar(t('notification.authUser.updateWaitingRoomAvailability.error'), { variant: 'error' })
    },
    requestTrackerSelector: selectAuthUserUpdateRequestState,
  })

  const updateStatus = (checked: boolean) => {
    if (!isStaff(authUser) || !authUser?.activeWaitingRooms || !waitingRoomId) return

    dispatch(
      updateMyProfile({
        activeWaitingRooms: checked
          ? authUser.activeWaitingRooms.concat(waitingRoomId)
          : authUser.activeWaitingRooms.filter((activeWaitingRoom) => activeWaitingRoom !== waitingRoomId),
      })
    )
  }

  return { checked, updateStatus }
}
